import { Component, OnInit, AfterViewInit, Input} from '@angular/core';
import {Router} from '@angular/router';
import { ServicesService } from '../services.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, AfterViewInit  {

    @Input() header: string;
    @Input() navbar: string;
    @Input() header_menu: string;
    @Input() cartCnt:number;
    userData = {};
    param = {};
    // cartCnt = '0';

    constructor(private _services: ServicesService, private router: Router) { }

    ngOnInit() {
        // window.initSticky();
        this.userData = JSON.parse(localStorage.getItem('userData'));
        const userToken = localStorage.getItem('userToken');

        if (userToken && this.userData) {
            this.param['id']    = this.userData['id'];
            this.param['token'] = userToken;
            this.cartCount();
        }


    }

    ngAfterViewInit() {
       // $('.tb-preloader-wave').fadeOut();
       // $('#tb-preloader').delay(200).fadeOut('slow').remove();
        if (this.header === 'l-header') {
            (<any>$('.js-primary-navigation')).menuzord();
        }
      // (<any>$('.js-primary-navigation')).menuzord();
    }

    public cartCount() {
        // console.log(this.param);
        this._services.cartCount(this.param).subscribe((cartData: any) => {
            if (cartData.status === 200) {
                this.cartCnt = cartData.result;
            }else {
                // this.router.navigate(['login']);
            }

            // console.log(this.cartCnt);
        }) ;
    }
    logout() {
        swal({
            // title: 'Are you sure?',
            text: 'Are you sure you want to log out?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.value) {
                localStorage.removeItem('userToken');
                localStorage.removeItem('userData');
                location.reload();
            }
        })
        // this.router.navigate(['login']);
    }
    deleteAccount(){
      
        const userData = JSON.parse(localStorage.getItem('userData'));
        const token = localStorage.getItem('userToken');
        const data = {'token': token };
        swal({
            title: 'Are you sure?',
            text: 'You Want To Delete The Account!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
          }).then(result => {
            if (result.value) {
                 this._services.deleteUserAccount(data).subscribe((data: any) => {
            if(data.status==200){
                localStorage.removeItem('userToken');
                localStorage.removeItem('userData');
                this.router.navigate(['login']);
                // location.reload();
              
            }
        
        });
             
            }
          });
       
    }
}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/header/header.component.ts